import { Link } from 'react-router-dom';
import { SafePhone, SafeEmail, SafeAddress } from '../SafeContact';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { href: '/hakkimizda', label: 'Hakkımızda' },
    { href: '/hizmetler', label: 'Hizmetlerimiz' },
    { href: '/projeler', label: 'Projelerimiz' },
    { href: '/surec', label: 'Süreç' },
    { href: '/iletisim', label: 'İletişim' },
  ];

  return (
    <footer data-testid="main-footer" className="bg-[#1a1a1a]">
      {/* Main content */}
      <div className="container-wide pt-20 lg:pt-28 pb-16 lg:pb-20">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-5">
            <Link to="/" className="inline-block mb-8" data-testid="footer-logo">
              <img
                src="/logo-vepera.png"
                alt="VE PERA İnşaat"
                className="h-12 w-auto brightness-0 invert"
              />
            </Link>
            <p
              className="text-[#d1d1d6]/50 leading-[1.9] max-w-sm text-[14px]"
              style={{ fontFamily: "var(--font-body)" }}
            >
              Güvenli yapılar, değerli yaşam alanları. Mühendislik mükemmelliği ve kalıcı değer yaratma vizyonuyla projeler geliştiriyoruz.
            </p>
          </div>

          {/* Navigation */}
          <div className="lg:col-span-3 lg:col-start-7">
            <span
              className="text-[10px] tracking-[0.2em] uppercase text-[#d1d1d6]/30 mb-8 block"
              style={{ fontFamily: "var(--font-body)", fontWeight: 500 }}
            >
              Keşfet
            </span>
            <ul className="space-y-4">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    data-testid={`footer-link-${link.href.replace('/', '')}`}
                    className="text-[#d1d1d6]/60 hover:text-[#b87333] transition-colors duration-300 text-[14px]"
                    style={{ fontFamily: "var(--font-body)" }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3 select-none" style={{ WebkitUserSelect: 'none', MozUserSelect: 'none', userSelect: 'none' }} onCopy={(e) => e.preventDefault()}>
            <span
              className="text-[10px] tracking-[0.2em] uppercase text-[#d1d1d6]/30 mb-8 block"
              style={{ fontFamily: "var(--font-body)", fontWeight: 500 }}
            >
              İletişim
            </span>
            <div className="space-y-5">
              <p
                className="text-[#d1d1d6]/60 text-[14px]"
                style={{ fontFamily: "var(--font-body)" }}
              >
                <SafePhone className="inline" style={{ fontFamily: "var(--font-body)" }} />
              </p>
              <p
                className="text-[#d1d1d6]/60 text-[14px]"
                style={{ fontFamily: "var(--font-body)" }}
              >
                <SafeEmail className="inline" style={{ fontFamily: "var(--font-body)" }} />
              </p>
              <p
                className="text-[#d1d1d6]/60 text-[14px] leading-[1.8]"
                style={{ fontFamily: "var(--font-body)" }}
              >
                <SafeAddress className="inline" style={{ fontFamily: "var(--font-body)" }} />
              </p>
            </div>

            {/* Socials */}
            <div className="flex gap-4 mt-8">
              <a
                href="#"
                data-testid="social-instagram"
                className="text-[#d1d1d6]/30 hover:text-[#b87333] transition-colors duration-300"
                aria-label="Instagram"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="#"
                data-testid="social-linkedin"
                className="text-[#d1d1d6]/30 hover:text-[#b87333] transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a
                href="#"
                data-testid="social-twitter"
                className="text-[#d1d1d6]/30 hover:text-[#b87333] transition-colors duration-300"
                aria-label="X"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="container-wide">
        <div className="border-t border-[#8e8e93]/15 py-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p
            className="text-[#8e8e93]/60 text-[12px] tracking-[0.05em]"
            style={{ fontFamily: "var(--font-body)" }}
          >
            &copy; {currentYear} VE PERA İnşaat. Tüm hakları saklıdır.
          </p>
          <div
            className="flex gap-8 text-[12px] text-[#8e8e93]/40"
            style={{ fontFamily: "var(--font-body)" }}
          >
            <a href="#" className="hover:text-[#b87333] transition-colors duration-300">
              Gizlilik Politikası
            </a>
            <a href="#" className="hover:text-[#b87333] transition-colors duration-300">
              Kullanım Koşulları
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
